import Model from './../../common/Model';

class Race extends Model {

	static fieldsInternal() {
		return ['date', 'post_time', 'title', 'race_name', 'broadcaster', 'image', 'track',
			'url', 'start', 'purse', 'distance', 'age_restriction', 'surface',
			'field_status', 'winning_time', 'rcn_video_id', 'signature',
			'triple_crown', 'breeders_cup'];
	}

	static relationships() {
		return ['broadcaster', 'track'];
	}

	static parse(attributes) {
		var self = this;
		return super.parse(attributes).then(function (instance) {
			self.parseDate(instance, 'date');
			self.parseDate(instance, 'post_time');
			return instance;
		});
	}

}

export default Race



/** WEBPACK FOOTER **
 ** ./site/sites/all/themes/custom/abr_theme/js/race-schedule/store/Race.js
 **/